

// import { useState, useEffect, useRef } from "react";
// import './BottomNavigation.css'
// const BottomNavigation = ({ items, setActive, activeItem }) => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const navRef = useRef(null);

//   const handleItemClick = (index, item) => {
//     setActiveIndex(index);
//     if (item?.handler) {
//       item.handler();
//     }
//   };

//   useEffect(() => {
//     const navElement = navRef.current;
//     if (navElement) {
//       const listItems = navElement.querySelectorAll("li");
//       if (listItems.length > 0) {
//         const itemWidth = listItems[0].clientWidth; // Get width of one list item
//         document.documentElement.style.setProperty("--indicator-width", `${itemWidth}px`);
//         document.documentElement.style.setProperty("--indicator-position", `${activeIndex * itemWidth}px`);
//       }
//     }
//   }, [activeIndex]);

//   return (
//     <div className="navigation container p-0" ref={navRef}>
//       <ul className="nav flex-row w-100 justify-content-around align-items-center mb-0">
//         {items.map((item, index) => (
//           <li
//             key={index}
//             className={`list ${activeItem === item.content || index === activeIndex ? "active" : ""}`}
//             onClick={() => {
//               setActive(item.content);
//               handleItemClick(index, item);
//             }}
//           >
//             <a className="nav-link text-center d-flex flex-column align-items-center">
//               <span className="icon">
//                 <span className="ion-icon">{item.icon}</span>
//               </span>
//               <span className="text">{item.text}</span>
//             </a>
//           </li>
//         ))}
//         <div className="indicator"></div>
//       </ul>
//     </div>
//   );
// };

// export default BottomNavigation;












import React from 'react';
import navBg from '../Assets/bottomimg.png'
import { FaBuilding, FaEllipsisH, FaHome, FaUser } from 'react-icons/fa';
import { MdOutlineAddHomeWork } from 'react-icons/md';
import { RxHome } from "react-icons/rx";
import { BiBuildingHouse } from 'react-icons/bi';
import { RiAccountCircleLine } from 'react-icons/ri';

const BottomNavigation = ({ activeItem, setActive }) => {
  const bottomNavItems = [
    { name: 'bottomHome', label: 'Home', icon: <RxHome /> },
    { name: 'bottomProperty', label: 'Properties', icon: <BiBuildingHouse  /> },
    { name: 'bottomBuyer', label: 'Assistant', icon:<RiAccountCircleLine /> },
    { name: 'bottomMore', label: 'More', icon: <FaEllipsisH /> },
  ];

  const navbarContainerStyle = {
width: "100%",
  };

const backgroundStyle = { 
  // backgroundImage: `url(${navBg})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  pointerEvents: 'auto',
  width: '100%',
  height: '100%',
};


  const itemStyle = (isActive) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: isActive ? '#2F747F' : '#888',
    fontWeight: isActive ? 'bold' : 'normal',
    fontSize: '12px',
    cursor: 'pointer',
    flex: 1,
  });

  const iconStyle = {
    fontSize: '22px',
    marginBottom: '4px',
  };

  const floatingButtonStyle = {
    position: 'absolute',
    // top: '-25px',
    bottom:"10px",
    left: '50%',
    transform: 'translateX(-50%)',
    width: '70px',
    height: '70px',
    backgroundColor: '#2F747F',
    borderRadius: '50%',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#fff',
    fontSize: '28px',
    zIndex: 20,
    pointerEvents: 'auto',
    cursor: 'pointer',
    border: '4px solid white',
  };

  return (
   <div style={backgroundStyle}>
  {[...bottomNavItems.slice(0, 2), { name: 'add', label: '', icon: <MdOutlineAddHomeWork /> }, ...bottomNavItems.slice(2)].map((item, index) => {
    const isAddButton = item.name === 'add';
    return (
      <div
        key={item.name}
        style={{
          ...itemStyle(activeItem === item.name),
          ...(isAddButton && {
            marginTop: '-30px',
            zIndex: 20,
            justifyContent: 'center',
            alignItems: 'center',
          }),
        }}
        onClick={() => !isAddButton ? setActive(item.name) : setActive('bottomAdd')}
      >
        <div style={isAddButton ? floatingButtonStyle : iconStyle}>{item.icon}</div>
        {!isAddButton && <div>{item.label}</div>}
      </div>
    );
  })}
</div>

  );
};

export default BottomNavigation;
